import { render, staticRenderFns } from "./TrafficRecord.vue?vue&type=template&id=3f43e84c&scoped=true"
import script from "./TrafficRecord.vue?vue&type=script&lang=js"
export * from "./TrafficRecord.vue?vue&type=script&lang=js"
import style0 from "./TrafficRecord.vue?vue&type=style&index=0&id=3f43e84c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f43e84c",
  null
  
)

export default component.exports